import { Component } from '@theme/component';

/**
 * Toggles between designer group tabs (e.g. Womens / Mens), showing the matching panel
 * and hiding the others.
 */
class Designers extends Component {
  /**
   * @param {MouseEvent} event
   */
  selectTab(event) {
    const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (!(tab instanceof HTMLElement)) return;

    const panelId = tab.getAttribute('aria-controls');
    if (!panelId) return;

    for (const otherTab of this.querySelectorAll('[role="tab"]')) {
      otherTab.setAttribute('aria-selected', otherTab === tab ? 'true' : 'false');
    }

    for (const panel of this.querySelectorAll('[role="tabpanel"]')) {
      if (!(panel instanceof HTMLElement)) continue;
      panel.hidden = panel.id !== panelId;
    }
  }
}

if (!customElements.get('designers-component')) {
  customElements.define('designers-component', Designers);
}
